<template>
  <div>
    <div id="fullpage">
      <!-- 第二页 -->
      <div class="section section2">
        <div class="page2">
          <div class="page_cent">
            <div class="content">
              <!-- app介绍 -->
              <div class="img_box">
                <div class="text_box">
                  <h1 class="head_name">九吨业务</h1>
                  <div class="icon_origin"></div>
                </div>
                <img class="img_log animated-content-left" :src="Business[page_app - 1].extends[0].image" />
                <p class="title animated-content-left">
                  {{ Business[page_app - 1].title }}
                </p>
                <p class="cont animated-content-left">
                  {{ Business[page_app - 1].desc }}
                </p>
                <div class="btn_list animated-content-left">
                  <div class="andio" v-if="Business[page_app - 1].extends[4].image">
                    <div class="my_btn">
                      <span>安卓</span>
                      <div class="QR_code">
                        <img :src="Business[page_app - 1].extends[4].image" />
                      </div>
                    </div>
                  </div>
                  <div class="ios" v-if="Business[page_app - 1].extends[5].image">
                    <div :class="Business[page_app - 1].extends[4].image
                      ? 'my_btn mar-left30'
                      : 'my_btn'
                      ">
                      <span>iOS</span>
                      <div class="QR_code">
                        <img :src="Business[page_app - 1].extends[5].image" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- app图片 -->
              <div class="app_img animated-content-rigth">
                <img class="app_tel" :src="Business[page_app - 1].extends[2].image" />
                <img :class="`${Business[page_app - 1].extends[1].class_first}`"
                  :src="Business[page_app - 1].extends[1].image" />
                <img :class="`${Business[page_app - 1].extends[1].class_two}`"
                  :src="Business[page_app - 1].extends[3].image" />
              </div>
            </div>
          </div>
          <div class="btns_bx">
            <div class="btns_bottom_box">
              <div class="img_btn">
                <img v-show="page_app !== 1" src="@/assets/img/back_btn.png" @click="backPage"
                  style="cursor: pointer" />
              </div>
              <div class="btns">
                <span class="page_btn">{{ page_app }}</span> /
                <span>{{ totle_app }}</span>
              </div>
              <div class="img_btn">
                <img v-show="page_app !== totle_app && totle_app != 1" src="@/assets/img/go_btn.png" @click="goPage"
                  style="cursor: pointer" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第一页 -->
      <div class="section section1">
        <div class="page1">
          <div class="content">
            <!-- 左边文字部分 -->
            <div class="text_box animated-content">
              <div class="top_box">
                <h1 class="title">业务合作</h1>
                <!-- <p class="en_title">Nintone Business</p> -->
                <div class="icon_origin mar-bottom75"></div>
              </div>
              <div class="box">
                <h1 class="title">移动APP广告合作</h1>
                <p class="name_title">姓名：王娇</p>
                <p class="email_title">邮箱：wangjiao@nineton.cn</p>
              </div>
            </div>
            <!-- 右边图片展示 -->
            <div class="img_box animated-content">
              <div class="img_erweima">
                <img src="@/assets/img/pic_23.png" />
              </div>
            </div>
            <div class="bg_img">
              <img src="@/assets/img/apps_bg.png" />
            </div>
          </div>
          <!-- 添加灰色背景区域 -->
          <div class="btns_bx">
            <div class="btns_bottom_box">
              <!-- 这里可以为空，只是为了保持一致的灰色背景样式 -->
            </div>
          </div>
        </div>
      </div>
      <!-- 第三页 -->
      <div class="section section3">
        <div class="page1">
          <div class="content">
            <div class="text_box">
              <h1 class="title">SDK业务</h1>
              <div class="icon_origin mar-bottom12"></div>
            </div>

            <!-- 广告SDK卡片 -->
            <div class="sdk-wrapper">
              <div class="sdk-card">
                <div class="sdk-version">广告SDK</div>
                <div class="sdk-info">
                  <div class="info-item">
                    <span class="label">SDK名称：</span>
                    <span class="value">【九吨Android广告SDK】&【九吨iOS广告SDK】</span>
                  </div>
                  <div class="info-item">
                    <span class="label">SDK所属企业名称：</span>
                    <span class="value">重庆市九吨科技有限公司</span>
                  </div>
                  <div class="info-item">
                    <span class="label">SDK说明：</span>
                    <span class="value">用于广告投放、广告监测、广告归因、广告效果优化</span>
                  </div>
                </div>
              </div>
              <div class="sdk-links">
                <a href="https://nineton.cn/advertising2.0.html" target="_blank">Android接入文档</a>
                <a href="https://nineton.cn/advertising_ios.html" target="_blank">iOS接入文档</a>
                <a href="https://nineton.cn/ad_privacy2.0.html" target="_blank">隐私政策</a>
                <a href="https://nineton.cn/sdk_guide2.0.html" target="_blank">合规使用文档</a>
              </div>
            </div>

            <!-- 统计SDK卡片 -->
            <div class="sdk-wrapper">
              <div class="sdk-card">
                <div class="sdk-version">统计SDK</div>
                <div class="sdk-info">
                  <div class="info-item">
                    <span class="label">SDK名称：</span>
                    <span class="value">【九吨Android统计SDK】&【九吨iOS统计SDK】</span>
                  </div>
                  <div class="info-item">
                    <span class="label">SDK所属企业名称：</span>
                    <span class="value">重庆市九吨科技有限公司</span>
                  </div>
                  <div class="info-item">
                    <span class="label">SDK说明：</span>
                    <span class="value">进行APP数据统计分析</span>
                  </div>
                </div>
              </div>
              <div class="sdk-links">
                <a href="https://nineton.cn/sdk_statistical_acc2.0.html" target="_blank">Android接入文档</a>
                <a href="https://nineton.cn/sdk_statistical_acc_ios.html" target="_blank">iOS接入文档</a>
                <a href="https://nineton.cn/analysis_privacy2.0.html" target="_blank">隐私政策</a>
                <a href="https://nineton.cn/sdk_statistic2.0.html" target="_blank">合规使用文档</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="xiahua" v-if="nowIndex != 2">
      <p v-if="someData == '1' && page_name == 'index'">
        <img @click="changeIndex" src="@/assets/img/xiahua.svg" />
      </p>
      <p v-else>
        <img @click="changeIndex" src="@/assets/img/xiahua_00.svg" />
      </p>
    </div>
  </div>
</template>

<script>
import fullpage from "fullpage.js";
// import { swiper.css, SwiperSlide } from 'vue-awesome-swiper'
import { mapGetters, mapActions } from "vuex";
import "swiper/css/swiper.css";
import Swiper from "swiper";
export default {
  data() {
    return {
      fillpage: null,
      page_app: 1,
      totle_app: 10,
      Business: [
        {
          id: "",
          title: "",
          subTitle: "",
          desc: "",
          sort: "",
          extends: [
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
          ],
        },
      ],
      page: 1,
      nowIndex: null,
      timer: null,
      backPageFlag: false,
      goPageFlag: false,
    };
  },
  created() {
  },
  mounted() {
    // 公司业务接口
    this.getBusiness();
    this.initSwiper();
    this.initFullPage();
    this.fillpage.moveTo(this.$route.query.page ? this.$route.query.page : 1);
    /* if(document.querySelector(".fp-completely")){
      document.querySelector(".fp-completely").classList.remove("active");
    }
    setTimeout(() => {
      if (document.querySelector(".fp-completely").classList) {
        document.querySelector(".fp-completely").classList.add("active");
      }
    }, 1000); */
  },
  computed: {
    ...mapGetters(["someData"]),
    ...mapGetters(["page_name"]),
  },
  // 销毁fullpage
  beforeDestroy() {
    /*     clearInterval(this.timer);
    this.timer = null; */
    if (this.fillpage) {
      this.fillpage.destroy("all");
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.fillpage
          ? this.fillpage.moveTo(
            this.$route.query.page ? this.$route.query.page : 1
          )
          : "";
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initFullPage() {
      let _this = this;
      this.fillpage = new fullpage("#fullpage", {
        onLeave: function (origin, destination, direction) {
          /* let animatedElements = origin.item.querySelectorAll(
            ".animated-content, .animated-content-left, .animated-content-top, .animated-content-rigth"
          );
          // 为每个元素移除动画类
          animatedElements.forEach((element) => {
            element.classList.remove("active");
          }); */
        },
        afterLoad: function (origin, destination, direction) {
          _this.nowIndex = destination.index;
          /* if (destination.index == 0) {
            _this.timer = setInterval(() => {
              if (_this.page_app + 1 > _this.totle_app) {
                if (document.querySelector(".fp-completely").classList) {
                  document
                    .querySelector(".fp-completely")
                    .classList.remove("active");
                }
                setTimeout(() => {
                  if (document.querySelector(".fp-completely").classList) {
                    document
                      .querySelector(".fp-completely")
                      .classList.add("active");
                  }
                  _this.page_app = 1;
                }, 800);
              } else {
                if (document.querySelector(".fp-completely").classList) {
                  document
                    .querySelector(".fp-completely")
                    .classList.remove("active");
                }
                setTimeout(() => {
                  if (document.querySelector(".fp-completely").classList) {
                    document
                      .querySelector(".fp-completely")
                      .classList.add("active");
                  }
                  _this.page_app += 1;
                }, 800);
              }
            }, 3000);
          } */
        },
        // sectionsColor: ['#f0f0f0', '#4BBFC3', '#7BAABE', 'whitesmoke', '#000'],
        // navigationTooltips: ['Section 1', 'Section 2', 'Section 3', 'Section 4', 'Section 5'],
        // anchors: ['section1', 'section3', 'section3', 'section4', 'section5'],
        // menu: '#menu',

        // 其他fullpage配置项...
      });
    },
    initSwiper() {
      new Swiper(".swiper", {
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    },
    backPage() {
      if (this.backPageFlag) {
        return;
      }
      this.backPageFlag = true;
      if (document.querySelector(".fp-completely").classList) {
        document.querySelector(".fp-completely").classList.remove("active");
      }
      setTimeout(() => {
        if (document.querySelector(".fp-completely").classList) {
          document.querySelector(".fp-completely").classList.add("active");
        }
        this.page_app -= 1;
        this.backPageFlag = false;
      }, 800);
    },
    // 翻页
    goPage() {
      if (this.goPageFlag) {
        return;
      }
      this.goPageFlag = true;
      if (document.querySelector(".fp-completely").classList) {
        document.querySelector(".fp-completely").classList.remove("active");
      }
      setTimeout(() => {
        if (document.querySelector(".fp-completely").classList) {
          document.querySelector(".fp-completely").classList.add("active");
        }
        this.page_app += 1;
        this.goPageFlag = false;
      }, 800);
    },
    // 插件路由
    navigateToSection(sectionIndex) {
      this.fillpage.moveTo(sectionIndex);
    },
    // 获取公司业务
    async getBusiness() {
      const [err, res] = await this.$http.get("business");
      if (err) {
        return;
      }
      this.Business = res.list;
      this.totle_app = res.list.length;
    },
    changeIndex() {
      this.fillpage.moveSectionDown();
    },
    /* clearTime() {
      clearInterval(this.timer);
      this.timer = null;
    },
    addTime() {
      this.timer = setInterval(() => {
        if (this.page_app + 1 > this.totle_app) {
          if (document.querySelector(".fp-completely").classList) {
            document.querySelector(".fp-completely").classList.remove("active");
          }
          setTimeout(() => {
            if (document.querySelector(".fp-completely").classList) {
              document.querySelector(".fp-completely").classList.add("active");
            }
            this.page_app = 1;
          }, 800);
        } else {
          if (document.querySelector(".fp-completely").classList) {
            document.querySelector(".fp-completely").classList.remove("active");
          }
          setTimeout(() => {
            if (document.querySelector(".fp-completely").classList) {
              document.querySelector(".fp-completely").classList.add("active");
            }
            this.page_app += 1;
          }, 800);
        }
      }, 3000);
    }, */
  },
};
</script>
<style scoped lang="less">
@import "../../assets/css/base.less";

.png18 {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.section1 {
  position: relative;

  .page1 {
    position: relative;
    height: 100vh;
    margin: 0 auto;

    .content {
      position: relative;
      padding: 164px 148px 0 240px;
      display: flex;
      justify-content: space-between;
      // 移除固定高度
      // height: calc(100vh - 340px);

      .text_box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 1.5625rem;

        .top_box {
          .title {
            font-size: 41px;
            font-weight: 600;
            color: #000000;
            line-height: 57px;
            font-family: "PingFang_Medium";
          }
        }

        .box {
          .title {
            font-size: 27px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: 52px;
          }

          .name_title {
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            margin: 16px 0;
          }

          .email_title {
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }

      .img_erweima {
        position: absolute;
        top: 0;
        right: 2.0417rem;
        z-index: 2;
        background: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .bg_img {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        position: relative;
        width: 671px;
        height: 557px;

        .btn {
          width: 188px;
          height: 45px;
          border-radius: 23px;
          border: 1px solid #979797;
          margin: 0 auto;
          font-size: 18px;
          font-weight: 400;
          color: #000000;
          line-height: 45px;
        }
      }
    }

    .btns_bx {
      position: absolute;  // 改为绝对定位
      bottom: 0;          // 固定在底部
      left: 0;
      height: 340px;
      background: rgba(216, 216, 216, 0.2);
      width: 100%;
      box-sizing: border-box;

      .btns_bottom_box {
        width: 1440px;
        margin: 0 auto;
        height: 100%;
      }
    }
  }
}

.section3 {
  position: relative;
  background-color: #f8f9fa;

  .page1 {
    position: relative;
    height: 100vh;
    margin: 0 auto;

    .content {
      position: relative;
      padding: 124px 148px 0 240px;   

      .text_box {
        position: relative;
        margin-bottom: 70px;

        .title {
          font-size: 41px;
          font-weight: 600;
          color: #000000;
          line-height: 57px;
          font-family: "PingFang_Medium";
        }
      }

      .sdk-wrapper {
        background: transparent;
        border-radius: 8px;
        margin-bottom: 60px;
        position: relative;
        display: flex;
        justify-content: space-between;
        width: 1200px;

        .sdk-card {
          flex: 1;
          padding: 40px 40px 40px 60px;
          position: relative;
          width: 900px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
          
          .sdk-version {
            position: absolute;
            top: -33px;
            left: 0;
            width: 242px;
            height: 66px;
            background: #242424;
            border-radius: 15px 15px 1px 15px;
            color: #fff;
            font-size: 18px;
            display: flex;
            align-items: center;
            padding-left: 25px;
          }

          .sdk-info {
            margin-top: 20px;

            .info-item {
              display: flex;
              margin-bottom: 15px;
              
              .label {
                min-width: 180px;
                color: #666;
                font-size: 16px;
              }
              
              .value {
                flex: 1;
                color: #333;
                font-size: 16px;
              }
            }
          }
        }

        .sdk-links {
          padding: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 30px;
          border-left: none;
          width: 300px;
          margin-left: 20px;

          a {
            color: #f7931e;
            text-decoration: none;
            font-size: 16px;
            display: flex;
            align-items: center;
            white-space: nowrap;
            padding-left: 20px;

            &:hover {
              text-decoration: underline;
            }

            &::after {
              content: '→';
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}

.section2 {
  position: relative;

  .page2 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;

    .page_cent {
      width: 1440px;
      padding: 164px 0 0 0;
      margin: 0 auto;
      .media1();
    }

    .page_title {
      margin-bottom: 57px;
    }

    .content {
      position: relative;
      display: flex;

      // justify- ent: space-between;
      // height: 557px;
      .text_box {
        // position: relative;
        // margin-right: 70px;
        // width: 279px;
        // padding-top: 120px;
        padding-left: 40px;
        margin-bottom: 50px;

        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;
        }
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        // padding-top: 38px;
        height: 600px;

        .img_log {
          width: 169px;
          height: 172px;
        }

        .title {
          font-size: 24px;
          font-weight: 600;
          color: #000000;
          line-height: 38px;
          padding-left: 40px;
          margin-bottom: 16px;
          font-family: "PingFang_Medium";
          margin-top: -40px;
        }

        .cont {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          line-height: 30px;
          padding-left: 40px;
          width: 580px;
          margin-bottom: 31px;
          font-family: PingFangSC-Regular, PingFang SC;
        }

        .btn_list {
          display: flex;
          padding-left: 40px;
          margin-bottom: 30px;
        }
      }

      .app_img {
        position: absolute;
        right: 80px;
        top: 0;

        .app_tel {
          width: 517px;
          height: 846px;
        }

        .app_time {
          width: 482px;
          height: 296px;
          position: absolute;
          bottom: 210px;
          left: -200px;
        }

        .app_banner {
          width: 455px;
          height: 177px;
          position: absolute;
          bottom: 165px;
          right: -170px;
        }

        .tianqi_app_time {
          width: 353px;
          height: 221px;
          position: absolute;
          bottom: 376px;
          left: -183px;
        }

        .tianqi_app_banner {
          width: 455px;
          height: 177px;
          position: absolute;
          bottom: 250px;
          right: -170px;
        }

        .kexiu_app_time {
          width: 398px;
          height: 271px;
          position: absolute;
          bottom: 240px;
          left: -150px;
        }

        .kexiu_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 180px;
          right: -100px;
        }

        .shouxie_app_time {
          width: 362px;
          height: 347px;
          position: absolute;
          bottom: 276px;
          left: -150px;
        }

        .shouxie_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 209px;
          right: -81px;
        }

        .meiyan_app_time {
          width: 421px;
          height: 296px;
          position: absolute;
          bottom: 240px;
          left: -220px;
        }

        .meiyan_app_banner {
          width: 353px;
          height: 177px;
          position: absolute;
          bottom: 179px;
          right: -97px;
        }

        .niannianshouzhang_app_time {
          width: 397px;
          height: 292px;
          position: absolute;
          bottom: 255px;
          left: -184px;
        }

        .niannianshouzhang_app_banner {
          width: 429px;
          height: 180px;
          position: absolute;
          bottom: 165px;
          right: -140px;
        }

        .yoyorichang_app_time {
          width: 480px;
          height: 328px;
          position: absolute;
          bottom: 210px;
          left: -254px;
        }

        .yoyorichang_app_banner {
          width: 427px;
          height: 152px;
          position: absolute;
          bottom: 190px;
          right: -108px;
        }

        .luyinzhuangjia_app_time {
          width: 173px;
          height: 609px;
          position: absolute;
          bottom: 200px;
          left: -80px;
        }

        .luyinzhuangjia_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 190px;
          right: -74px;
        }

        .jiantongkuan_app_time {
          width: 398px;
          height: 253px;
          position: absolute;
          bottom: 253px;
          left: -149px;
        }

        .jiantongkuan_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 180px;
          right: -90px;
        }

        .zy_app_time {
          width: 353px;
          height: 333px;
          position: absolute;
          bottom: 252px;
          left: -165px;
        }

        .zy_app_banner {
          width: 455px;
          height: 177px;
          position: absolute;
          bottom: 225px;
          right: -149px;
        }

        .qy_app_time {
          width: 362px;
          height: 347px;
          position: absolute;
          bottom: 240px;
          left: -134px;
        }

        .qy_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 180px;
          right: -80px;
        }

        .aizimu_app_time {
          width: 407px;
          height: 317px;
          position: absolute;
          bottom: 230px;
          left: -204px;
        }

        .aizimu_app_banner {
          width: 487px;
          height: 180px;
          position: absolute;
          bottom: 180px;
          right: -150px;
        }

        .yl_app_time {
          width: 398px;
          height: 278px;
          position: absolute;
          bottom: 234px;
          left: -152px;
        }

        .yl_app_banner {
          width: 434px;
          height: 156px;
          position: absolute;
          bottom: 190px;
          right: -140px;
        }

        .nldc_app_banner {
          width: 455px;
          height: 177px;
          position: absolute;
          bottom: 250px;
          right: -265px;
        }
      }
    }

    .btns_bx {
      height: 340px;
      background: rgba(216, 216, 216, 0.2);
      width: 100%;
      box-sizing: border-box;

      .btns_bottom_box {
        display: flex;
        padding: 87px 0 0 212px;
        width: 1440px;
        margin: 0 auto;
      }

      img {
        width: 70px;
        height: 70px;
      }

      .img_btn {
        width: 70px;
        height: 70px;
      }

      .btns {
        font-size: 14px;
        color: #000000;
        margin: 0 35px;

        .page_btn {
          color: #e28a2b;
          font-size: 20px;
          font-weight: 600;
          line-height: 70px;
        }
      }
    }
  }

  .my_btn {
    width: 160px;
    height: 45px;
    border-radius: 23px;
    border: 1px solid #979797;
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    line-height: 45px;
    position: relative;
    cursor: pointer;

    .QR_code {
      position: absolute;
      top: 50px;
      right: 0;
      transform: scale(0);
      transition: all 0.15s;

      img {
        width: 160px;
        height: 160px;
        border-radius: 18px;
      }
    }

    &:hover {
      background: #f7931e;
      border: 1px solid #f7931e;
      box-shadow: 0px 15px 34px 0px rgba(247, 147, 30, 0.45);
      border-radius: 37px;
      color: #fff;

      & {
        .QR_code {
          position: absolute;
          top: 50px;
          right: 0;
          transform: scale(1);
          transition: all 0.15s;

          img {
            width: 160px;
            height: 160px;
            border-radius: 18px;
            box-shadow: 0px 9px 63px 0px #e8e8e8;
          }
        }
      }
    }
  }
}

.xiahua {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1500;

  img {
    cursor: pointer;
  }
}

.animated-content-left {
  opacity: 0;
  transform: translateX(-300px);
  transition: opacity 1.5s ease-in-out, transform 1.5s ease-in-out;
}

.first_active .animated-content-left {
  opacity: 1 !important;
  transform: translateX(0) !important;
}

.animated-content-rigth {
  opacity: 0;
  transform: translateX(300px);
  transition: opacity 1.5s ease-in-out, transform 1.5s ease-in-out;
}

.first_active .animated-content-rigth {
  opacity: 1 !important;
  transform: translateX(0) !important;
}
</style>
